import React, {Fragment} from 'react';
import classes from './Homepage.module.css';
import Login from '../../containers/Login/Login';
import instagram from '../../assets/instagram.png';

const homepage = (props) => {
    return(
        <Fragment>
            <div className={classes.background}>
            </div>
            <div className={classes.home}>
                <Login />
                <div className={classes.intro}>
                    <p>Welcome to FakeInsta</p>
                    <p>This is a replica of Instagram made for fun</p>
                    <p>Creator: Amitav Mishra</p>
                    <p>Original Credit:
                        <a href="https://instagram.com"> instagram.com 
                        <img src={instagram} alt="instagram" width="22" height="22" style={{transform:'translate(10px, 5px)'}} />
                        </a> 
                    </p>
                    <p>Icons credit: <a href="https://icons8.com/">Icons8</a> & 
                    <a href="https://fontawesome.com/"> FontAwesome</a></p>
                </div> 
            </div>
        </Fragment>
    );
}

export default homepage;